import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 1267",
  "use": "icon-Group 1267-usage",
  "viewBox": "0 0 16.414 16.414",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.414 16.414\" id=\"icon-Group 1267\">\n  <g id=\"icon-Group 1267_Group_1267\" data-name=\"Group 1267\" transform=\"translate(-866.493 -16.293)\">\n    <line id=\"icon-Group 1267_Line_111\" data-name=\"Line 111\" x1=\"15\" y2=\"15\" transform=\"translate(867.2 17)\" fill=\"none\" stroke=\"#333\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\n    <line id=\"icon-Group 1267_Line_112\" data-name=\"Line 112\" x1=\"15\" y1=\"15\" transform=\"translate(867.2 17)\" fill=\"none\" stroke=\"#333\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 1267.svg
// module id = AwQm
// module chunks = 3